import React from 'react';
import { Box } from '@heycater/design-system';
import { BoxProps } from '@material-ui/core';
import { StaticImageData } from 'next/image';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import sumupImg from '@images/food-program-page/customer-reasons/sumup.png';
import CustomerExample from 'static_pages/foodProgram/CustomerExample';
import { FoodProgramH2 } from 'static_pages/foodProgram/Utils';
import Container from 'system/components/Container';

const sumupExample = createExample('sumup', sumupImg);

function createExample(keyFragment: string, image: StaticImageData) {
  const base = 'customerExamples';
  return {
    titleKey: `${base}.${keyFragment}.title`,
    situationKey: `${base}.${keyFragment}.situation`,
    solutionKey: `${base}.${keyFragment}.solution`,
    resultKey: `${base}.${keyFragment}.result`,
    image,
  };
}

const CustomerExamples = (props: BoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation('food_program');

  return (
    <Box as="section" textAlign="center" {...props}>
      <Container size={860}>
        <FoodProgramH2 mb={{ xs: 5, md: 9 }}>
          <Trans
            t={t}
            i18nKey="customerExamples.title"
            components={{
              '1': <Box as="span" color={theme.palette.secondary[400]} />,
              '2': <br />,
            }}
          />
        </FoodProgramH2>
      </Container>
      <Container size={960}>
        <Box mb={5} position="relative">
          <CustomerExample
            image={sumupExample.image}
            title={t(sumupExample.titleKey)}
            situation={t(sumupExample.situationKey)}
            solution={t(sumupExample.solutionKey)}
            results={t(sumupExample.resultKey)}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default CustomerExamples;
